import * as React from "react";
import { cx } from "../../helpers/utils/cx";
export function renderHelperTextDefault(_ref) {
  let {
    error,
    disabled,
    helperText,
    helperTextId
  } = _ref;
  if (!helperText) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cx("bolt-font-body-s-regular text-secondary", disabled && "text-tertiary", error && "text-danger-primary"),
    id: helperTextId
  }, helperText);
}